import React from 'react';
import SvgSemaforYellowAml from '../../../img/icons/semafor_yellow_aml';
import SvgSemaforGreenAml from '../../../img/icons/semafor_green_aml';
import SvgSemaforRedAml from '../../../img/icons/semafor_red_aml';

class Semaphore extends React.Component {

    render() {
        if (this.props.color === "yellow")
            return <SvgSemaforYellowAml {...this.props} />
        if (this.props.color === "red")
            return <SvgSemaforRedAml {...this.props} />
        if (this.props.color === "green")
            return <SvgSemaforGreenAml {...this.props} />
        return null;
    }
}

export default Semaphore;